module.exports = "images/apple-icon-114x114.18d3153be2c2d5451c7c25b9b65a2721.png";